import { pxToRem } from '@withjoy/joykit/theme';
import { ADMIN_SHELL_BAR_HEIGHT } from '@apps/admin/components/AdminShell/AdminShell.constants';

/**
 * Header-height constants for the admin header bar.
 *
 * Kept in their own module (no `styled()` components, no `ParticleJoyLogo`) so
 * lightweight consumers — loading skeletons pulled into the synchronous/pre-chunk
 * graph, or pages that size an iframe or a side nav against the viewport below the
 * header — can read the dimensions without dragging in the full
 * `AdminHeaderBar.styles` dependency graph.
 */

/**
 * Height of the header's main row, in px, at every breakpoint: the shared admin shell bar (the
 * website editor's height). Anything laid out against the viewport below a fixed header —
 * iframes, sticky side navs, scroll clearances — subtracts this, never a literal, so it follows
 * the header if the shell spec changes.
 */
export const ADMIN_HEADER_HEIGHT = ADMIN_SHELL_BAR_HEIGHT;

/** Height of the second row mobile tab navigation wraps onto below `md`, in px. */
export const MOBILE_NAV_ROW_HEIGHT = 48;

/** `ADMIN_HEADER_HEIGHT` as rem, shared by Root and Spacer so a fixed header and its spacer can't drift. */
export const HEADER_HEIGHT = pxToRem(ADMIN_HEADER_HEIGHT);
